import apiInstance from '../utils/axiosConfig';

/**
 * Service dédié aux nouvelles routes d'inscription combinées
 * (User + Client en une requête, ou User + Professional en une requête).
 */
const UserRegistrationService = {
    // Inscription Client : userData + clientData (facultatif) + fichiers (facultatifs)
    registerClient: async ({ userData, clientData, profilePhoto, identityDocument }) => {
        try {
            const formData = new FormData();
            formData.append('userData', JSON.stringify(userData));
            if (clientData) {
                formData.append('clientData', JSON.stringify(clientData));
            }
            if (profilePhoto) {
                formData.append('profilePhoto', profilePhoto);
            }
            if (identityDocument) {
                formData.append('identityDocument', identityDocument);
            }

            const response = await apiInstance.post('/registration/registerClient', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return response.data;
        } catch (error) {
            console.error('Error registering client:', error.message || error);
            throw error;
        }
    },

    // Inscription Professionnel : userData + professionalData + fichiers (tous facultatifs sauf userData)
    registerProfessional: async ({
                                     userData,
                                     professionalData,
                                     profilePhoto,
                                     identificationFrontDoc,
                                     identificationBackDoc,
                                     criminalRecordFrontDoc,
                                     criminalRecordBackDoc,
                                     cv,
                                     locationPlan,
                                 }) => {
        try {
            const formData = new FormData();
            formData.append('userData', JSON.stringify(userData));
            if (professionalData) {
                formData.append('professionalData', JSON.stringify(professionalData));
            }
            if (profilePhoto) formData.append('profilePhoto', profilePhoto);
            if (identificationFrontDoc) formData.append('identificationFrontDoc', identificationFrontDoc);
            if (identificationBackDoc) formData.append('identificationBackDoc', identificationBackDoc);
            if (criminalRecordFrontDoc) formData.append('criminalRecordFrontDoc', criminalRecordFrontDoc);
            if (criminalRecordBackDoc) formData.append('criminalRecordBackDoc', criminalRecordBackDoc);
            if (cv) formData.append('cv', cv);
            if (locationPlan) formData.append('locationPlan', locationPlan);

            const response = await apiInstance.post('/registration/registerProfessional', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return response.data;
        } catch (error) {
            console.error('Error registering professional:', error.message || error);
            throw error;
        }
    },
};

export default UserRegistrationService;